import React from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import PropTypes from 'prop-types'

const PhoneInputComponent = ({
    value = '',
    onChange,
    disabled = false,
    size = 'sm',
    className = '',
    placeholder = '',
    autoFormat = true,
    onlyCountries = ['us'],
    ...rest
}) => {
    // Size mapping for input height
    const inputHeight = {
        sm: '32px',
        md: '40px',
        lg: '48px'
    }

    return (
        <PhoneInput

            // className='disabled:opacity-50 disabled:bg-[#F3F4F6]'
            country={'us'}
            autoFormat={autoFormat}
            value={value || ''}
            onChange={onChange}
            onlyCountries={onlyCountries}
            disabled={disabled}
            disableCountryCode={false}
            disableDropdown={true}
            countryCodeEditable={false}
            placeholder={placeholder || 'Enter phone number'}
            containerStyle={{
                width: '100%',
                ...rest.containerStyle
            }}
            inputStyle={{
                // disabled: 'opacity-50 bg-[#F3F4F6]',
                backgroundColor: `${disabled ? '#F3F4F6' : ''}`,
                width: '100%',
                height: inputHeight[size] || inputHeight.sm,
                ...rest.inputStyle
            }}
            {...rest}
        />
    )
}

// Display component for non-editable phone numbers
export const PhoneDisplay = ({ value, className = '' }) => {
    const formatPhoneNumber = (phone) => {
        if (!phone) return '-'
        // Remove all non-digit characters
        const digits = phone.replace(/\D/g, '')

        // Format as US phone number: +1 (XXX) XXX-XXXX
        if (digits.length === 10) {
            // 10 digits - format directly with +1 prefix
            return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
        } else if (digits.length === 11 && digits[0] === '1') {
            // 11 digits starting with 1 (US country code) - remove country code and add +1 prefix
            return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`
        } else if (digits.length > 0 && digits.length < 10) {
            // Partial number - return as is or format what we can
            return phone
        } else if (digits.length > 11) {
            // More than 11 digits - might have extra formatting, try to extract last 10
            const last10 = digits.slice(-10)
            return `+1 (${last10.slice(0, 3)}) ${last10.slice(3, 6)}-${last10.slice(6)}`
        }
        // Fallback - return original if we can't format
        return phone
    }

    return (
        <p className={`text-sm text-[#6B7280] font-normal w-22 ${className}`}>
            {formatPhoneNumber(value)}
        </p>
    )
}

PhoneDisplay.propTypes = {
    value: PropTypes.string,
    className: PropTypes.string,
}

PhoneInputComponent.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    className: PropTypes.string,
    placeholder: PropTypes.string,
    autoFormat: PropTypes.bool,
    onlyCountries: PropTypes.array,
}

export default PhoneInputComponent

